import React, { useContext, useEffect, useRef, useState } from 'react'
import { Context } from '../Context/Context'
import close from '../Components/Images/x-close.png';

const DeleteInvoice = ({ setDeleteInvoiceBar, setDeleteInvoiceErrorBar }) => {
    const { deleteInvoice, handleDeleteInvoice, setViewInvoice, setDeleteInvoice, fetchInvoices } = useContext(Context)
    const DeleteModel = useRef()
    const [invoiceDetails, setInvoiceDetails] = useState([])
    const [isSubmitting, setIsSubmitting] = useState(false);


    const closeRef = (e) => {
        if (DeleteModel.current === e.target) {
            handleDeleteInvoice()
        }
    }

    useEffect(() => {

        if (!deleteInvoice) return

        const token = localStorage.getItem('token');
        const invoiceID = localStorage.getItem('invoiceID');

        const fetchInvoices = async () => {
            const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/invoices/${invoiceID}`, {
                method: "GET",
                headers: {
                    Authorization: `Token ${token}`,
                },
            });
            const data = await res.json();
            setInvoiceDetails(data);
        };

        fetchInvoices();
    }, [deleteInvoice]);

    const deleteAnInvoice = async (e) => {
        e.preventDefault()
        setIsSubmitting(true)

        const token = localStorage.getItem('token');
        const invoiceID = localStorage.getItem('invoiceID');

        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/invoices/${invoiceID}`, {
            method: "DELETE",
            headers: {
                Authorization: `Token ${token}`,
                "Content-Type": "application/json",
            },
        });

        let data = {};
        try {
            // Only try to parse JSON if there's something to parse
            const text = await res.text();
            data = text ? JSON.parse(text) : {};

            if (!res.ok) {
                setDeleteInvoiceErrorBar(true)
                throw new Error(data.message || 'Failed');
            } else {
                console.log('Invoice deleted:', data);
                window.scrollTo(0, 0);
                setDeleteInvoice(false);
                setDeleteInvoiceBar(true);
                setViewInvoice(false)
                fetchInvoices()
            }
        } catch (err) {
            console.warn('No JSON response or invalid JSON:', err);
            setDeleteInvoiceErrorBar(true)
        } finally {
            setIsSubmitting(false)
        }
    };


    return (
        <div onClick={closeRef} ref={DeleteModel} className={`fixed flex items-center justify-center z-50 inset-0 bg-opacity-30 bg-black/40 ${deleteInvoice ? 'block' : 'hidden'}`}>
            <div className='bg-white w-[460px] 2xl:w-[20%] lg:ml-[200px] mx-3 shadow-lg rounded-xl flex flex-col justify-center py-5 px-7'>
                <div className='flex justify-between gap-3'>
                    <div>
                        <p className='text-[18px] text-[#1D1C1F] font-medium mb-2'>Delete invoice?</p>
                        <p className='text-[#525154]'>This will permanently delete {invoiceDetails.payer_name} from your invoice list.</p>
                    </div>
                    <img
                        className='size-5 mt-1 cursor-pointer' src={close} alt=""
                        onClick={handleDeleteInvoice}
                    />
                </div>
                <div className='flex justify-end gap-2 mt-12'>
                    <button
                        className='p-3 rounded-lg w-[30%] border-[1.2px] text-[#525154] text-[14px] border-black/10'
                        onClick={handleDeleteInvoice}
                    >
                        Cancel
                    </button>
                    <button
                        className='p-3 rounded-lg font-medium bg-[#FEEDED] text-[#EF4444] text-[14px] w-[30%]'
                        onClick={deleteAnInvoice}
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? (
                            'Deleting...'
                        ) : (
                            'Delete'
                        )}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default DeleteInvoice